import { Popover } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import {   __experimentalHStack as HStack,__experimentalVStack as VStack,
    __experimentalText as Text, __experimentalToggleGroupControl as ToggleGroupControl,
    __experimentalToggleGroupControlOption as ToggleGroupControlOption,__experimentalToolsPanelItem as ToolsPanelItem ,
    Button
} from '@wordpress/components';
import {VayuBlocksBackground} from  '@vayu-blocks';

const backgroundAnimationMap = {
	'shadow-pulse': { className: 'shadow-pulse', label: 'shadow' },
	'wave-pulse': { className: 'wave-pulse', label: 'wave' },
	'glow-pulse': { className: 'glow-pulse', label: 'glow' },
	'shadow-expand': { className: 'shadow-expand', label: 'expand' },
	'radial-glow': { className: 'radial-glow', label: 'radial' },
	'ripple-wave': { className: 'ripple-wave', label: 'ripple' },
    'two-wave': { className: 'two-wave', label: 'pulse' },
};

const backgroundanimationoptions = [
	{ label: __('None', 'vayu-blocks'), value: 'none' },
	...Object.entries(backgroundAnimationMap).map(([value, data]) => ({
		label: data.label,
		value,
	})),
];

export const Background = ({setisbackgroundVisible,backgroundPopoverAnchor,animationData,dataKey, onChange}) => {

    const getbackgroundAnimationClass = (value) => {
        switch (value) {
            case 'shadow-pulse':
                return 'animation-preview shadow-pulse';
            case 'wave-pulse':
                return 'animation-preview wave-pulse';
            case 'glow-pulse':
                return 'animation-preview glow-pulse';
            case 'shadow-expand':
                return 'animation-preview shadow-expand';
            case 'radial-glow':
                return 'animation-preview radial-glow';
            case 'ripple-wave':
                return 'animation-preview ripple-wave';
            case 'two-wave':
                return 'animation-preview vb-two-wave';
            default:
                return ''; // Return an empty string if no match
        }
    };

    const handlebackgroundAnimationClick = (animation) => {
        const currentHoverType = animationData?.background?.type || 'always';
    
        const updatedAnimationData = {
            ...animationData,
            background: {
                ...animationData.background,
                value: animation,
                type: currentHoverType, // ensures default if missing
            },
        };
    
        onChange(dataKey, updatedAnimationData);
    };
    
    const handleEffectColorChange = (value) => {
            const updatedAnimationData = {
                ...animationData,
                background: {
                    ...animationData.background,
                    bg: value,
                },
            };
        
            onChange(dataKey, updatedAnimationData);
        };
        

  return (
        <Popover
        placement="left-start"
        className="vayu_blocks_toolspanel_items_popover"
        anchor={backgroundPopoverAnchor}
        onClose={() => setisbackgroundVisible(false)}
        offset={35}
        resize
    >
        <VStack  style={{padding:'10px',width: '280px'}}>
        
            <Text>
                <h4>{__('Background Effects','vayu-blocks')}</h4>
                <p>{__('Select a background effect for your element.','vayu-blocks')}</p>
            </Text>

            <Text>
                <HStack spacing="3" wrap={true}  justify="flex-start">
                <Text className="vayu_blocks_selected_saniamtion">
                    {backgroundanimationoptions.map(({ label, value }) => (
                        <Text
                            key={value}
                            style={{border:'none',padding:'6px'}}
                            className={`vayu-blocks-ihover-main-panel vayu_blocks_animation_panel_button_svg animation-card ${
                                animationData?.background?.value === value ? 'selected' : ''
                            }`}
                            onClick={() => handlebackgroundAnimationClick(value)}
                        >
                            {value === 'none' ? (
                                    <div style={{margin:'0px 3px'}} className={`vayu-blocks-panel-ihover vayu-blocks-none-button`} ></div>
                            ) : (
                                <Text
                                    className={`vayu-blocks-panel-ihover height-upgrade-effect-animation vayu_blocks_animation_panel_svg ${getbackgroundAnimationClass(value)}`}
                                    style={{ width: '45px', height: '45px',fontSize:'10px',color:'#6C1BC3',border:'none'}}
                                >{label}</Text>
                            )}

                        </Text>
                    ))}
                </Text>
                </HStack>
            </Text>

            <br/>

            <Text>
                <VayuBlocksBackground
                    onChange={(key,value)=>handleEffectColorChange(value)}
                    colorPanel = {[
                        {
                            active: ['color'],
                            label: 'Wrapper',
                            key:'animationData',
                            value: animationData?.background?.bg,
                        },
                    ]}
                />

            </Text>

            <Text>
                <ToggleGroupControl
                    className="togglegroupcontrol-vayu-blcoks-image-border-frame"
                    __next40pxDefaultSize
                    __nextHasNoMarginBottom
                    isBlock
                    value={ animationData.background.type || 'always' }
                    onChange={(value) => {
                        const updatedAnimationData = {
                            ...animationData,
                            background: {
                                ...animationData?.background,
                                type: value,
                            },
                        };
                    
                        onChange(dataKey, updatedAnimationData);
                    }}
                    
                > 
                    <ToggleGroupControlOption
                        label={__('Always','vayu-blocks')}
                        value="always"
                    />
                    <ToggleGroupControlOption
                        label= {__('On Hover','vayu-blocks')}
                        value="onhvr" 
                    />

                    </ToggleGroupControl>
                                            
            </Text>

        </VStack>
        </Popover>
  )
}

export const BackgroundEffectPanel = ({
	animationData,
	isbackgroundVisible,
	setisbackgroundVisible,
	setbackgroundPopoverAnchor,
    dataKey, onChange
}) => {

    const getbackgroundAnimationClass = (value) => {
        switch (value) {
            case 'shadow-pulse':
                return 'animation-preview shadow-pulse';
            case 'wave-pulse':
                return 'animation-preview wave-pulse';
            case 'glow-pulse':
                return 'animation-preview glow-pulse';
            case 'shadow-expand':
                return 'animation-preview shadow-expand';
            case 'radial-glow':
                return 'animation-preview radial-glow';
            case 'ripple-wave':
                return 'animation-preview ripple-wave';
            default:
                return ''; // Return an empty string if no match
        }
    };

    const handlebackgroundAnimationClick = (animation) => {
        const currentHoverType = animationData?.background?.type || 'always';
    
        const updatedAnimationData = {
            ...animationData,
            background: {
                ...animationData.background,
                value: animation,
                type: currentHoverType, // ensures default if missing
            },
        };
    
        onChange(dataKey, updatedAnimationData);
    };

    const selectedBackgroundEffect =Object.entries(backgroundAnimationMap).find(
        ([_, data]) => data.className === animationData?.background?.value
    )?.[1].label || '';

	return (
		<ToolsPanelItem
			className="vayu_blocks_animation_toolspanel_item"
			hasValue={() =>
				!!animationData?.background?.value && animationData?.background?.value !== 'none'
			}
			label={__('Background', 'vayu-blocks')}
			onDeselect={() => handlebackgroundAnimationClick('none')}
			isShownByDefault
		>
			<Button
				ref={setbackgroundPopoverAnchor}
				onClick={() => setisbackgroundVisible(!isbackgroundVisible)}
				className={`block-editor-panel-animation-settings__dropdown ${isbackgroundVisible ? 'is-open' : ''}`}
			>
				<HStack alignment="left">
					{!animationData?.background?.value || animationData?.background?.value === 'none' ? (
						<div className="vayu-blocks-panel-ihover vayu-blocks-none-button toolaspanel-size-none-button vayu_blocks_none" />
					) : (
						<div
							style={{ marginLeft: 0}}
							className={`vayu_blocks_hstack_animation_panel_image vayu_blocks_hstack_animation_panel_image_color ${getbackgroundAnimationClass(animationData?.background?.value)}`}
						/>
					)}
					<Text style={{ marginLeft: '5px' }}>{selectedBackgroundEffect || __('None')}</Text>
				</HStack>
			</Button>
		</ToolsPanelItem>
	);
};
